import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

const todayIso = () => new Date().toISOString().split('T')[0];

const ActivateDialog = ({ open, onClose, onConfirm }) => {
  const [startDate, setStartDate] = useState(todayIso());

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Registrar reingreso</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Se creará un nuevo período laboral. El historial anterior se conservará.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          type="date"
          label="Fecha de reingreso"
          value={startDate}
          onChange={(event) => setStartDate(event.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button onClick={() => onConfirm(startDate)} disabled={!startDate}>Reactivar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivateDialog;
